import { render, staticRenderFns } from "./emptyContainer.vue?vue&type=template&id=7d2224d6&scoped=true&"
import script from "./emptyContainer.vue?vue&type=script&lang=js&"
export * from "./emptyContainer.vue?vue&type=script&lang=js&"
import style0 from "./emptyContainer.vue?vue&type=style&index=0&id=7d2224d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2224d6",
  null
  
)

export default component.exports